// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectIntegrations = (state:RootState) => state[Reducers.Integrations].integrations;
export const selectIntegration = (state:RootState) => state[Reducers.Integrations].integration;
export const selectLoading = (state:RootState) => state[Reducers.Integrations].loading;
